import React from 'react';
import './Loading.css'; // Import the CSS file for styling
import { ThemeContext } from '../../contexts/ThemeContext';
import { useContext } from 'react';

const Loading = () => {
    const {theme} = useContext(ThemeContext)
  return (
    <div className="loading-container">
      <div className="loading-spinner" style={{borderLeftColor: theme.primary}}></div>
    </div>
  );
};

export default Loading;